import {
  AttendanceClassIllustration,
  CurriculumIllustration,
  MobilePhoneIcon,
  SchoolEventIllustration,
  UpdateIcon,
} from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SubstitutionsSetupPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canManageSubstitution()}
      title={`${t('substitutions.title', { count: 2 })} ${t('substitutions.setup').toLowerCase()}`}
    >
      <IconMenu headline={t('common.whatToSetup')} hasMarginBottom>
        <IconMenuItem
          label={t('functionClass.title', { count: 2 })}
          icon={<AttendanceClassIllustration />}
          bubbleType={7}
          onClick={() => navigate(t('routes.functionClass.slug'))}
        />
      </IconMenu>
      <IconMenu headline={t('settings.title', { count: 2 })}>
        <IconMenuItem
          label={t('synchronizations.manualSynchronization')}
          icon={<UpdateIcon />}
          bubbleType={8}
          onClick={() => navigate(t('routes.manualSynchronization.slug'))}
        />
        <IconMenuItem
          label={t('substitutions.substitutionPlan')}
          icon={<CurriculumIllustration style={{ strokeWidth: '1.5' }} />}
          bubbleType={5}
          onClick={() => navigate(t('routes.substitutionPlanSettings.slug'))}
        />
        <IconMenuItem
          label={t('substitutions.app.title')}
          icon={<MobilePhoneIcon />}
          bubbleType={9}
          disabled={!permissions?.isSubstitutionAppEnabled()}
          onClick={() => navigate(t('routes.substitutionAppSettings.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
